import styled, { css } from "styled-components";
import type { RefObject } from "react";
import { theme } from "../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import IconWrapper from "../../../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";

export const CollapsableHeader = styled.summary<{ multiRowHeader?: boolean }>`
    display: grid;
    position: relative;
    grid-template-columns: 1fr minmax(150px, auto);
    align-items: center;
    gap: ${theme.space[1]}px;
    width: 100%;
    padding: ${theme.space[2]}px;
    background-color: ${theme.colors.primaryWhite};

    &::marker,
    &::-webkit-details-marker {
        display: none;
        width: 0;
        height: 0;
        content: "";
    }
    ${({ multiRowHeader }) =>
        multiRowHeader &&
        css`
            @media ${getBreakpoint("down", "sm")} {
                grid-template-columns: 1fr;
            }
        `}
    @supports not (gap: 0) {
        grid-gap: ${theme.space[1]}px;
    }
`;

export const CollapsableHeaderContent = styled.div<{ $icon: boolean }>`
    display: grid;
    grid-template-columns: ${($icon) => ($icon ? "4rem 1fr" : "1fr")};
    align-items: center;
    gap: 1rem;

    ${IconWrapper} {
        display: flex;
    }
`;

export const CollapsableTitleSection = styled.div`
    display: grid;
`;

export const CollapsableContent = styled.div`
    border-top: 1px solid ${theme.colors.grey2};
`;

export const StyledCollapsable = styled.details<{ ref?: RefObject<HTMLDetailsElement> }>`
    border: 1px solid ${theme.colors.grey2};
`;
